angular.module('routes.publish.PublishPayloadResolver', [
  'stack'
])

/**
 * The PublishPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class PublishPayloadResolver
 * @constructor
 * @module routes.publish.PublishPayloadResolver
 */
.factory('PublishPayloadResolver', [
  '$q',
  'GLOBAL',
  'ModelsService',
  function ($q, GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      var queue = [];

      if (!params.caseId) {
        queue.push(ModelsService.initialize('cases', GLOBAL.apiPath + '/cases'));
      } else {
        queue.push(ModelsService.get('cases', GLOBAL.apiPath + '/cases', { id: params.caseId }));
      }

      return $q
        .all(queue)
        .then(function (caseResponse) {
          queue = [];

          if (params.caseId) {
            queue = _(caseResponse[0].relatives)
              .filter({ model: 'publicatioPns' })
              .map(function (relative) {
                return ModelsService.get(
                  relative.model,
                  GLOBAL.apiPath + '/' + relative.model,
                  { id: relative.id }
                );
              })
              .value();
          }

          return $q.all(queue);
        })
        .then(function () {
          return {};
        });
    };
  }
]);
